import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import { SettingsStore, Component } from '../../../client';
import { lodash as _ } from '../../../common';
import Priority from '../../../components/issues/Priority';

class FlagSelector extends Component {
   constructor() {
      super();
      this.stores = [SettingsStore];
      this.storeKeys = ['priorities'];
   }

   _onChange = (event) => {
      const parsed = parseInt(event.target.value, 10);
      this.props.onChange(Number.isNaN(parsed) ? null : parsed);
   };

   render() {
      const sourceFlags = this.props.priorities || this.state.priorities || [];
      const options = _.sortBy(_.filter(sourceFlags, (flag) => !flag.deleted), ['order']);
      const selected = _.find(options, (flag) => String(flag.no) === String(this.props.noPriority));
      const value = this.props.noPriority == null ? '' : this.props.noPriority;

      return (
         <div className='FlagSelector'>
            <Grid container spacing={1} alignItems='center'>
               <Grid item xs>
                  <TextField
                     id={this.props.id}
                     select
                     fullWidth
                     required={this.props.required}
                     disabled={this.props.disabled}
                     error={this.props.error}
                     label={this.props.label}
                     value={value}
                     onChange={this._onChange}
                     InputLabelProps={{ shrink: true }}
                     SelectProps={{ native: true }}
                     helperText={this.props.helperText}
                     margin='normal'
                     variant={this.props.variant}
                     className='select-flag'>
                     <option value=''>{this.props.selectionLabel}</option>
                     {options.map((option) => (
                        <option key={option.no} value={option.no}>{option.name}</option>
                     ))}
                  </TextField>
               </Grid>
               <Grid item>{selected && <Priority color={selected.color} />}</Grid>
            </Grid>
         </div>
      );
   }
}

FlagSelector.defaultProps = {
   id: 'select-flag',
   priorities: null,
   noPriority: null,
   label: 'Priority',
   selectionLabel: 'Select priority',
   helperText: '',
   variant: 'outlined',
   required: false,
   disabled: false,
   error: false,
   onChange: () => {}
};

FlagSelector.propTypes = {
   id: PropTypes.string,
   priorities: PropTypes.array,
   noPriority: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
   label: PropTypes.string,
   selectionLabel: PropTypes.string,
   helperText: PropTypes.string,
   variant: PropTypes.oneOf(['outlined', 'standard']),
   required: PropTypes.bool,
   disabled: PropTypes.bool,
   error: PropTypes.bool,
   onChange: PropTypes.func
};

export default FlagSelector;
